export default __webpack_public_path__ + "static/media/placeholder_portfolio02-es-mobile.c230ab4a.png";